import { createFileRoute } from '@tanstack/react-router';
import BookmarkListPage from '../components/BookmarkListPage';
import { useUserPreferences } from '../hooks/useUserPreferences';
import { useVideoBookmarks } from '../services/dataHooks';
import { validateListPageSearch } from '../utils/listPageSearch';

export const Route = createFileRoute('/_app/videos/')({
  validateSearch: validateListPageSearch,
  component: VideosIndexPage,
});

function VideosIndexPage() {
  const search = Route.useSearch();
  const page = search.page ?? 1;
  const navigate = Route.useNavigate();
  const { preferences } = useUserPreferences();
  const {
    bookmarks,
    hasMore,
    isLoading: isBookmarkCollectionLoading,
    isError,
    refetch,
  } = useVideoBookmarks(page);

  const updatePageSearch = (nextPage: number) => {
    const safePage = Math.max(1, nextPage);
    navigate({
      replace: true,
      search: (prev) => {
        if (safePage <= 1) {
          if (prev.page === undefined) return prev;
          const { page: _page, ...rest } = prev;
          return rest;
        }
        if (prev.page === safePage) return prev;
        return { ...prev, page: safePage };
      },
    });
  };

  return (
    <BookmarkListPage
      mode="videos"
      bookmarks={bookmarks}
      currentPage={page}
      condensedView={preferences.bookmarkList.view === 'condensed'}
      showThumbnails={preferences.bookmarkList.thumbnails}
      isLoading={isBookmarkCollectionLoading}
      isError={isError}
      onRetry={refetch}
      hasMore={hasMore}
      onPageChange={updatePageSearch}
    />
  );
}
